<template>
  <div>
    <Title>{{ lesson.title }}</Title>
    <div v-if="lesson.steps && lesson.steps.length > 0">
      <div v-for="step in lesson.steps" :key="step.id">
        <LessonStep :step="step" />
      </div>
    </div>
    <div v-else>
      <p>
        This lesson has no content yet. Come back some other time, maybe?
      </p>
      <p class="caption">
        In the meantime, you may
        <router-link :to="{ name: 'lessons' }"
          >browse our lesson collection</router-link
        >.
      </p>
    </div>
  </div>
</template>

<script>
import LessonStep from "@/components/LessonStep.vue";

export default {
  name: "Lesson",
  components: { LessonStep },
  props: {
    lesson: Object
  }
};
</script>
